import { render, staticRenderFns } from "./SetRemindModal.vue?vue&type=template&id=25548aec&scoped=true"
import script from "./SetRemindModal.vue?vue&type=script&lang=js"
export * from "./SetRemindModal.vue?vue&type=script&lang=js"
import style0 from "./SetRemindModal.vue?vue&type=style&index=0&id=25548aec&prod&lang=scss&scoped=true"
import style1 from "./SetRemindModal.vue?vue&type=style&index=1&id=25548aec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25548aec",
  null
  
)

export default component.exports